import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { AllTrainings as TR } from '../../features/training'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function AllTrainings(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <TR id={props.id} />
}
